export const DECLARACAO_ATIVIDADE_IMPRESSAO_SOLICITADA = 'DECLARACAO_ATIVIDADE_IMPRESSAO_SOLICITADA';
export const DECLARACAO_ATIVIDADE_IMPRESSAO_RECEBIDA = 'DECLARACAO_ATIVIDADE_IMPRESSAO_RECEBIDA';
export const DECLARACAO_ATIVIDADE_ERRO_IMPRESSAO_RECEBIDO = 'DECLARACAO_ATIVIDADE_ERRO_IMPRESSAO_RECEBIDO';
export const DECLARACAO_ATIVIDADE_LIMPAR_MENSAGEM = 'DECLARACAO_ATIVIDADE_LIMPAR_MENSAGEM';
export const DECLARACAO_ATIVIDADE_NAO_ENCONTRADA = 'DECLARACAO_ATIVIDADE_NAO_ENCONTRADA';
export const DECLARACAO_ATIVIDADE_ERRO_ELO = 'DECLARACAO_ATIVIDADE_ERRO_ELO';
